let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fF1MD")).then(() => parcelRequire('9xzfy'));